import {customDocumentEvent} from "../../../webpack/modules/events";

customDocumentEvent('productGlassReversedChanged', function(event) {
    //TODO
});